import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import FounderMsg from "./founderMsg";
import RevenueImpact from "./RevenueImpact";
import SmallMsg from "./SmallMsg";
import AboutCompany from "./AboutCompany";
import FunFact from "../../components/funfact/FunFact";
import OurValues from "../Home/OurValues";
import InternationalDesk from "./InternationalDesk";

const AboutCompanyPage = () => {
  return (
    <Fragment>
      <PageTitle pageTitle={"About Us"} pagesub={"About"} />
      {/* <RevenueImpact /> */}
      <FounderMsg />
      <AboutCompany showTitle={true} />
      <FunFact theme="light" />
      <OurValues showTitle={true} theme="light" />
      <InternationalDesk />
      <SmallMsg />
      <Scrollbar />
    </Fragment>
  );
};
export default AboutCompanyPage;
